export default __webpack_public_path__ + "static/media/shooting.8e706950.mp4";